<template>
        <aside
            v-if="!cookieConsentAcknowledged"
            class="cookie-consent"
            :class="{ 'cookie-consent--open': isOpen }"
            aria-live="polite">

            <p class="cookie-consent__text">We use cookies to offer you a better, more personalized browsing experience. By using the website, you are giving your consent for us to use cookies.
                <span v-if="linkPrivacy || linkTerms">
                    Read our
                    <a v-if="linkPrivacy" :href="linkPrivacy">Privacy Policy</a>
                    <span v-if="linkTerms && linkPrivacy"> and </span>
                    <a  v-if="linkTerms" :href="linkTerms">Terms & Conditions</a>.
                </span>
            </p>

            <button class="cf-button cf-button--yelling cf-button--primary cookie-consent__ok" title="Close Cookie Consent Banner" @click="acceptCookieConsent">
                OK
            </button>

            <button class="cookie-consent__close" title="Close Cookie Consent Banner" @click="acceptCookieConsent">
                <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                    <path d="M1.20117 1L21.0002 20.799M1.20117 21L21.0002 1.20101" stroke="currentColor" stroke-linecap="round"/>
                </svg>
            </button>
        </aside>
</template>

<script>
export default {
    name: 'CookieConsent',
    props: {
        linkTerms: { type: String },
        linkPrivacy: { type: String },
    },
    data: () => ({
        isOpen: false,
    }),
    
    computed: {
        cookieConsentAcknowledged() {
            return localStorage.getItem("cookieConsentAcknowledged");
        }
    },
    created() {
        
    },
    mounted() {
        if (!this.cookieConsentAcknowledged) {
            this.display();
        }
    },
    methods: {
        display() {
            this.isOpen = true;
            document.body.classList.add("cookie-consent-active");
        },
        acceptCookieConsent() {
            localStorage.setItem("cookieConsentAcknowledged", true);
            this.isOpen = false;
            document.body.classList.remove("cookie-consent-active");
        }
        
    }
};
</script>


// WEBPACK FOOTER //
// resources/components/apps/cookie-consent.vue